import { render } from "./TemplatesTable.vue?vue&type=template&id=53c40520&ts=true"
import script from "./TemplatesTable.vue?vue&type=script&lang=ts"
export * from "./TemplatesTable.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src455085550/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__